export default __webpack_public_path__ + "static/media/azure_new.c1c133ec.png";